import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='decisionHandler' subtitle='PrimerPaymentCreationDecisionHandler' label='Required' mdxType="Item">
	<Group summary='Methods' mdxType="Group">
        <Item title='continuePaymentCreation()' mdxType="Item">
          <p>{`Call `}<inlineCode parentName="p">{`continuePaymentCreation()`}</inlineCode>{` when you want to continue with the payment creation.`}</p>
        </Item>
		<Item title='abortPaymentCreation(errorMessage)' mdxType="Item">
          <p>{`Call `}<inlineCode parentName="p">{`abortPaymentCreation(errorMessage)`}</inlineCode>{` when you want to abort the payment. Optionally you can provide an error message to get presented on the error screen.`}</p>
        </Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      